import { GroupConfigurationCategory } from '@/modules/group/modules/groups/domain/models/GroupConfigurationCategory'

import { axios, Response } from '../index'

export type PersonaSummary = {
  personaId: string
  fullName: string
  personaType: string
  avatarUrl: string
  inviteSent: boolean
  avatarName: string
}

const getGroupNotMembers = (
  groupId?: string,
  groupCategory?: GroupConfigurationCategory
): Response<PersonaSummary[]> => {
  return axios.get(`/v1/groups/${groupId}/not-members`, {
    params: {
      category: groupCategory
    }
  })
}

export default getGroupNotMembers
